import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { AlertComponent } from '../../alert/alert.component';
import { BeneficialOwnerService } from 'src/app/services/beneficial-owner.service';
import { CustomValidation } from 'src/app/helpers/customValidation';

@Component({
  selector: 'app-beneficial-owner',
  templateUrl: './beneficial-owner.component.html',
  styleUrls: ['./beneficial-owner.component.css']
})
export class BeneficialOwnerComponent implements OnInit {

  boForm: FormGroup;
  restrictTabFlag = true;
  benList: any = [];
  editBenData: any = [];
  editBenID: any = [];
  dob: any;
  dateofdeclarationundersection90: any;
  dateOfCessation: any;
  dateOfEntry: any;
  dateOfBEN2: any;
  dateOfdobModel: any;
  dateOfddu90Model: any;
  dateOfCessationModel: any;
  dateOfEntryModel: any;
  dateOfBEN2Model: any;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  disabledOnclick: boolean;
  countryList: any[];

  constructor(private beneficialOwnerService: BeneficialOwnerService, private activatedRoute: ActivatedRoute,
    private directorMasterService: DirectorMasterService, private commonFunction: CommonFunction, private alert: AlertComponent, 
     private customValidation: CustomValidation,private router: Router) { }

  ngOnInit() {
    this.boForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z. ']*$"), this.customValidation.noWhitespaceValidator]),
      address: new FormControl('', []),
      email: new FormControl('', [Validators.required, Validators.email]),
      dob: new FormControl('', []),
      fathername: new FormControl('', [Validators.pattern("^[a-zA-Z. ']*$")]),
      occupation: new FormControl('', [Validators.pattern("^[a-zA-Z. ']*$")]),
      nationality: new FormControl('', [Validators.pattern("^[a-zA-Z. ']*$")]),
      pan: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      cin: new FormControl('', [Validators.minLength(21), Validators.maxLength(21), Validators.pattern("^[a-zA-Z0-9]*$")]),
      passport: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      status: new FormControl('', []),
      dateofdeclarationundersection90: new FormControl('', []),
      dateOfCessation: new FormControl('', []),
      dateOfEntry: new FormControl('', []),
      dateOfBEN2: new FormControl('', []),
      amount: new FormControl('', [Validators.pattern("^[0-9]*$")]),
      otherInterest: new FormControl('', []),
      instructionIf: new FormControl('', [])
    })

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabFlag = false;
        this.editBenID = params['particularId'];
        this.putbeneficialOwnerById(this.editBenID);
      } else {
        this.restrictTabFlag = true;
      }
    })
    this.getAllNations();

  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['ben3list']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  getAllNations() {
    // this.kmpPersonalForm.controls.Nationality.setValue("null");
    this.directorMasterService.getNations().subscribe((relativeUpdate:any) => {
      console.log(relativeUpdate);
      this.countryList = this.commonFunction.sortByKey(relativeUpdate.countryList, 'Country');
    });
    // this.kmpPersonalForm.controls.Nationality.setValue("null");
  }

  showFormEntry() {
    this.disabledOnclick = true;

    // this.restrictTabFlag=false;
    var object = {
      name: this.boForm.controls.name.value,
      address: this.boForm.controls.address.value,
      email: this.boForm.controls.email.value,
      dob: this.setDate(this.boForm.controls.dob.value),
      fathername: this.boForm.controls.fathername.value,
      occupation: this.boForm.controls.occupation.value,
      nationality: this.boForm.controls.nationality.value,
      pan: this.boForm.controls.pan.value,
      cin: this.boForm.controls.cin.value,
      passport: this.boForm.controls.passport.value,
      status: this.boForm.controls.status.value,
      dateofdeclarationundersection90: this.setDate(this.boForm.controls.dateofdeclarationundersection90.value),
      dateOfCessation: this.setDate(this.boForm.controls.dateOfCessation.value),
      dateOfEntry: this.setDate(this.boForm.controls.dateOfEntry.value),
      dateOfBEN2: this.setDate(this.boForm.controls.dateOfBEN2.value),
      amount: this.boForm.controls.amount.value,
      otherInterest: this.boForm.controls.otherInterest.value,
      instructionIf: this.boForm.controls.instructionIf.value,
    }
    this.beneficialOwnerService.samplebeneficialOwnerRecord(object).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'ben3list');
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    })
  }

  putbeneficialOwnerById(BenID) {
    this.beneficialOwnerService.updateBen(BenID).subscribe(response => {
      this.editBenData = response.data[0];
      this.boForm.controls.name.setValue(this.editBenData.name);
      this.boForm.controls.address.setValue(this.editBenData.address);
      this.boForm.controls.email.setValue(this.editBenData.email);
      this.boForm.controls.fathername.setValue(this.editBenData.fathername);
      this.boForm.controls.occupation.setValue(this.editBenData.occupation);
      this.boForm.controls.nationality.setValue(this.editBenData.nationality);
      this.boForm.controls.pan.setValue(this.editBenData.pan);
      this.boForm.controls.cin.setValue(this.editBenData.cin);
      this.boForm.controls.passport.setValue(this.editBenData.passport);
      this.boForm.controls.status.setValue(this.editBenData.status);
      this.boForm.controls.amount.setValue(this.editBenData.amount);
      this.boForm.controls.otherInterest.setValue(this.editBenData.otherInterest);
      this.boForm.controls.instructionIf.setValue(this.editBenData.instructionIf);

      if (this.editBenData.dob != null) {
        let dt = new Date(this.setFormatDate(this.editBenData.dob));
        this.dateOfdobModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editBenData.dateofdeclarationundersection90 != null) {
        let dt = new Date(this.setFormatDate(this.editBenData.dateofdeclarationundersection90));
        this.dateOfddu90Model = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editBenData.dateOfCessation != null) {
        let dt = new Date(this.setFormatDate(this.editBenData.dateOfCessation));
        this.dateOfCessationModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editBenData.dateOfEntry != null) {
        let dt = new Date(this.setFormatDate(this.editBenData.dateOfEntry));
        this.dateOfEntryModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editBenData.dateOfBEN2 != null) {
        let dt = new Date(this.setFormatDate(this.editBenData.dateOfBEN2));
        this.dateOfBEN2Model = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }

    })
  }


  updatebeneficialOwner() {
    this.disabledOnclick = true;
    var object = {
      name: this.boForm.controls.name.value,
      address: this.boForm.controls.address.value,
      email: this.boForm.controls.email.value,
      dob: this.setDate(this.boForm.controls.dob.value),
      fathername: this.boForm.controls.fathername.value,
      occupation: this.boForm.controls.occupation.value,
      nationality: this.boForm.controls.nationality.value,
      pan: this.boForm.controls.pan.value,
      cin: this.boForm.controls.cin.value,
      passport: this.boForm.controls.passport.value,
      status: this.boForm.controls.status.value,
      dateofdeclarationundersection90: this.setDate(this.boForm.controls.dateofdeclarationundersection90.value),
      dateOfCessation: this.setDate(this.boForm.controls.dateOfCessation.value),
      dateOfEntry: this.setDate(this.boForm.controls.dateOfEntry.value),
      dateOfBEN2: this.setDate(this.boForm.controls.dateOfBEN2.value),
      amount: this.boForm.controls.amount.value,
      otherInterest: this.boForm.controls.otherInterest.value,
      instructionIf: this.boForm.controls.instructionIf.value,
    }
    this.beneficialOwnerService.updatebeneficialOwner(object, this.editBenID).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'ben3list');
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    })
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }


  generateOutput() {
    this.beneficialOwnerService.generatebeneficialOwnerDocument(this.editBenID).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editBenID);
          setTimeout(function () {
            self.downloadPdfDocument(self.editBenID);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.beneficialOwnerService.downloadbeneficialOwnerFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.beneficialOwnerService.downloadbeneficialOwnerPdfFile(id, 'Single');
  }

}
